import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './FontSizeInput.scss';
import { TextInput } from '../../FormComponents/TextInput/TextInput';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const FontSizeInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const [ fontSize, setFontSize ] = useState<number>(project.encoder.overlayFontSize);
  const debounce = 100;
  const min = 10;
  const max = 60;

  const onAfterChange = (data: string) => {
    if (project.encoder) {  
      let value = fontSize;
   
      if (value < min) {
        value = min;
      } else if (fontSize > max) {
        value = max;
      }

      setFontSize(value);

      if (project.stream?.sourceLanguageIsoCode === project.encoder?.languageIsoCode) {
        updateStream({
          overlayFontSize: value,
        }, debounce);
      } else {
        updateEncoder(project.encoder, {
          overlayFontSize: value,
        }, debounce);
      }
    }
  };

  useEffect(() => {
    setFontSize(project.encoder.overlayFontSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.encoder.overlayFontSize]);

  return (
    <div className="font-size-input">
      <div className="input-title">
        {t('producer.inputs.font-size.title')}
        <Help
          title="Font Size"
          text="Font Size adjusts how large the text appears in Open Captions.<br/><br/>- Increasing the font size makes captions easier to read, especially on smaller screens.<br/>- Decreasing the font size allows more text to fit within the caption box, but may reduce readability.<br/><br/>Adjust this setting to balance readability with the amount of text displayed on screen."
        />
      </div>
      <TextInput
        placeholder="producer.inputs.font-size.placeholder"
        value={fontSize.toString()}
        onChange={(value) => {setFontSize(parseInt(value))}}
        onAfterChange={onAfterChange}
        validate={false}
        number={true}
      />
      <button className="btn btn-apply btn-secondary btn-no-margin btn-margin-right" type="button">Apply</button>
      <div className="input-component-footer">{t('producer.inputs.font-size.footer')}</div>
    </div>
  );
};

export default React.memo(FontSizeInput);
